import type { BuildingStats } from "building-types/options/buildingStats";
import type { OptionChoices } from "building-types/options/optionChoices";
import type { PlanStats } from "building-types/options/optionTemplateTypes";
import { formatOptionPrice } from "lib/options/pricing";

export function planStatsLookup(
  stats: PlanStats,
  optionChoices: OptionChoices,
  key: keyof BuildingStats,
): number | string | undefined {
  return stats[JSON.stringify(optionChoices)]?.[key];
}

export function getPlanStat(
  planStats: PlanStats | null | undefined,
  planStatsField: keyof BuildingStats,
  prefix?: string,
  countWord?: string,
): string {
  if (!planStats) {
    return "";
  }
  const value = planStats["default"]?.[planStatsField] ?? 0;

  const singular = value === 1;

  let pluralizedCountWord = "";

  if (countWord) {
    if (singular) {
      pluralizedCountWord = " " + countWord;
    } else {
      pluralizedCountWord = " " + countWord + "s";
    }
  }

  const prefixString = prefix ? prefix : "";
  const price = formatOptionPrice(value as number);

  return `${prefixString}${price}${pluralizedCountWord}`;
}

export function hasPlanStat(stats: PlanStats | null | undefined, planStatsField: keyof BuildingStats): boolean {
  return !!stats && !!stats["default"]?.[planStatsField];
}

export function getPreferredFloorArea(stats: PlanStats | null | undefined): {
  floorArea: number;
  usesFallback: boolean;
} {
  if (hasPlanStat(stats, "conditionedFloorArea")) {
    return {
      floorArea: stats?.["default"]?.conditionedFloorArea ?? 0,
      usesFallback: false,
    };
  }
  return {
    floorArea: stats?.["default"]?.totalFloorArea ?? 0,
    usesFallback: true,
  };
}
